export default "__VITE_ASSET__CVNz0_UV__"